import moment from "moment"
import Service from "../../../Services/index";

const BillingRE = {
    namespaced: true,
    state: {
        billings_re: [],
        billing_details : [],
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        SET_BILLINGS_RE: (state, res) => {
            state.billings_re = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        SET_BILLINGS_RE_DETAILS: (state, res) => {
            state.billing_details = res;
        },
    },
    actions: {
        getBillings({ state, commit },page) {
            return Service.BillingRE.getBillingRE(page).then(data=>{
                commit("SET_BILLINGS_RE",data);
            })
        },
        showBilling({commit},id){
            return Service.BillingRE.showBillingRE(id).then(data=>{
                commit("SET_BILLINGS_RE_DETAILS",data);
            })
        },
        saveBillingRE({state , commit},{id,data}){
            return Service.BillingRE.createBillingRE(data).then(()=>{
                console.log("create RE success");
            })
        },
        searchBillingRE({commit},data){
            return Service.BillingRE.searchBillingRE(data).then(res=>{
                commit("SET_BILLINGS_RE",res);
            })
        },
        deleteBillingRE({commit},id){
            return Service.BillingRE.deleteBillingRE(id);
        }
    }
};

export default BillingRE
